import React from "react";

import {Link} from 'react-router'

/**
 *
 * @param parentCrumbs - Array of link object with shape {to: '', url: '', text: ''}
 * @param title - String (required)
 * @returns {React.JSX.Element}
 * @constructor
 */
function BreadCrumbsBar({ parentCrumbs = [], title }) {
    return (
        <header id="topbar" className="alt affix">
            <div className="topbar-left">
                <ol className="breadcrumb">
                    <li className="crumb-active">
                        <a href="#" onClick={(e) => e.preventDefault()}>{title}</a>
                    </li>
                    <li className="crumb-icon">
                        <a href="/#/portal" title={"Portal"}>
                            <span className="glyphicon glyphicon-home"></span>
                        </a>
                    </li>
                    {parentCrumbs && parentCrumbs.map(function (link, i) {
                        let element = <span>{link.text}</span>;
                        if (link.to) {
                            element = <Link to={link.to}>{link.text}</Link>;
                        } else if (link.url) {
                            element = <a href={link.url}>{link.text}</a>;
                        }
                        return (
                            <li className="crumb-link hidden-xs" key={i}>
                                {element}
                            </li>);
                    })}
                    <li className="crumb-trail hidden-sm hidden-md hidden-lg">{title}</li>
                </ol>
            </div>
            <div className="topbar-right">
            </div>
        </header>
    )
}

export default BreadCrumbsBar;